import { Switch } from "@launchmetrics/lm-ui";
import { useTranslation } from "react-i18next";
import { useReportSettings } from "../../hooks";

export const GroupLocation: React.FC = () => {
	const { t } = useTranslation();
	const [reportSettings, setReportSettings] = useReportSettings();

	return (
		<Switch
			checked={reportSettings?.groupedByCountry}
			label={t('reports.group_by_country')}
			onChange={() => setReportSettings({groupedByCountry: !(reportSettings?.groupedByCountry ?? false)})}
			size='medium'
		/>
	);
};
